import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/logo.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center" >
          <Col size={12} sm={6} style={{marginTop:'15px'}}>
            <img src={logo} alt="Logo" className="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              
            </div>
            <p>gdsc.iitk@gmail.com</p>
            <p>Indian Institute of Technology, Kanpur</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
